import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem'
    },
    box: {
      display: 'flex',
      justifyContent: 'start',
      padding: '1rem'
    },
    title: {
      height: '30px',
      width: '40%'
    }
  },
  content: {
    main: {
      padding: '1rem',
      backgroundColor: 'white'
    },
    bar: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '120px'
    },
    content: {
      height: '100%',
      borderRadius: '50%',
      width: '120px'
    }
  },
  paragraph: {
    main: {
      marginTop: '1rem'
    },
    text: {
      height: '40px'
    }
  }
};

const SkeletonTravelsGuideContainerMobile = (props) => {
  const [className, style] = useStyles(props);
  const { content, paragraph } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonTravelsGuideContainer"
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={content.main}>
            <Row gutters>
              <Col style={content.bar}>
                <Box className="fr-skeleton-element" style={content.content} />
              </Col>
              <Col style={content.bar}>
                <Box className="fr-skeleton-element" style={content.content} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={content.main}>
            <Row gutters>
              <Col style={content.bar}>
                <Box className="fr-skeleton-element" style={content.content} />
              </Col>
              <Col style={content.bar}>
                <Box className="fr-skeleton-element" style={content.content} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="6" style={paragraph.main}>
          <Box className="fr-skeleton-box" style={paragraph.text} />
        </Col>
        <Col xs="6" style={paragraph.main}>
          <Box className="fr-skeleton-box" style={paragraph.text} />
        </Col>
      </Row>
    </Box>
  );
};
SkeletonTravelsGuideContainerMobile.componentName = 'SkeletonTravelsGuideContainerMobile';

export default SkeletonTravelsGuideContainerMobile;
